export type CustomerDetailsTasksTranslation = {
  title: string;
};

export const customerDetailsTasksTranslation: CustomerDetailsTasksTranslation = {
  title: 'Zadania',
};
